import { objectToQueryString } from "../helpers/ApiHelper";
import { ICareProvider } from "../models/ICareProvider";
import { IOrthodonticLkgCfPatientSearchParams, IOrthodonticLkgCfPatient, IOrthodonticLkgCfPatientStatus, IOrthodonticLkgCfPatientType, IOrthodonticLkgCfPatientAgeInterval } from "../models/IOrthodonticLkgCfPatient";
import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";

export class OrthodonticLkgCfPatientSearchApi extends ApiClient {
    searchOrthodonticLkgCfPatients(searchParams: IOrthodonticLkgCfPatientSearchParams, success: (data: IPaginatedResponse<IOrthodonticLkgCfPatient[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch?${queryString}`, success, error, final);
    }

    searchOrthodonticLkgCfPatientsAsExcel(searchParams: IOrthodonticLkgCfPatientSearchParams, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch?${queryString}&exportToExcel=true`, fileName, success, error, final);
    }

    getOrthodonticLkgCfPatientStatuses(success: (data: IOrthodonticLkgCfPatientStatus[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch/statuses`, success, error, final);
    }

    getOrthodonticLkgCfPatientTypes(success: (data: IOrthodonticLkgCfPatientType[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch/patientTypes`, success, error, final);
    }

    getOrthodonticLkgCfPatientAgeIntervals(success: (data: IOrthodonticLkgCfPatientAgeInterval[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch/ageIntervals`, success, error, final);
    }

    getUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch/umbrellaOrganisations`, success, error, final);
    }

    getCareProvidersByUmbrellaOrganisationCareProviderId(umbrellaOrganisationCareProviderId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/orthodonticLkgCfPatientSearch/careProviders/${umbrellaOrganisationCareProviderId}`, success, error, final);
    }
}